import { Component } from '@angular/core';

@Component({
  selector: 'sem-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css'],
  standalone: true
})
export class RedirectComponent {

  constructor() { }
}
